export const INSTANCE_PATH = 'languages';

export const DEFAULT_LOCALE = 'en';
